import { css } from '@emotion/css'
import { borderRadius } from '../../styles'
import { colors } from '../../themes'

const styles = {
  table: css({
    width: '100%',
    tableLayout: 'fixed',
    backgroundColor: colors.mystic,
    borderRadius: borderRadius.default,
    borderCollapse: 'collapse',
    borderSpacing: 0,
  }),
}

export default styles
